var _path, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M28.9427 8.37233V25.1356M25.1329 4.5625H8.36966M25.1329 28.9454H8.36966M4.55983 8.37233V25.1356",
    stroke: "#0036DD",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.9428,
    cy: 4.55983,
    r: 3.80983,
    fill: "#0036DD",
    stroke: "#0036DD",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.55983,
    cy: 4.55983,
    r: 3.80983,
    fill: "#0036DD",
    stroke: "#0036DD",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.9428,
    cy: 28.9387,
    r: 3.80983,
    fill: "#0036DD",
    stroke: "#0036DD",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.55983,
    cy: 28.9387,
    r: 3.80983,
    fill: "#0036DD",
    stroke: "#0036DD",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale);
export default __webpack_public_path__ + "static/media/Scale.d6bd07737f882969bdaa49794d869469.svg";
export { ForwardRef as ReactComponent };